import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { PopupsManagerService } from './services/popups-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private viewContainerRef: ViewContainerRef,
    private popupsManagerService: PopupsManagerService
  ) {}

  ngOnInit(): void {
    this.popupsManagerService.initialize(this.viewContainerRef);
  }
}
